var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAddress = function SvgAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.293 4.357a.5.5 0 0 0-.646-.64L2.962 8.495a.5.5 0 0 0 .012.94l5.54 1.918a.5.5 0 0 1 .308.306l1.904 5.365a.5.5 0 0 0 .94.005l4.627-12.672Z",
    stroke: "#818C96",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.293 4.357a.5.5 0 0 0-.646-.64L2.962 8.495a.5.5 0 0 0 .012.94l5.54 1.918a.5.5 0 0 1 .308.306l1.904 5.365a.5.5 0 0 0 .94.005l4.627-12.672Z",
    stroke: "#747F88",
    strokeLinecap: "round"
  })));
};

export default SvgAddress;